import ApiSunoMock from '../providers/ApiSunoMock';

class ApiSuno {
    constructor(classeObjeto=ApiSunoMock){
        this.classeObjeto = new classeObjeto();
    }

    getRentabilidade(rentabilidadeId, success, error){
        return this.classeObjeto.getRentabilidade(rentabilidadeId, success, error);
    }

    getIpca(success, error){
        return this.classeObjeto.getIpca(success, error);
    }
}
export default ApiSuno